import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <img src={logo} alt="Chess at Sea emblem" />
            <div>
              <div className="footer-logo">Chess <span>at Sea</span></div>
              <p>
                A professional chess enrichment residency for the world's great ocean liners —
                and a wider mission to bring chess to schools, communities, and the NHS.
              </p>
            </div>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><Link to="/programme">The Programme</Link></li>
              <li><Link to="/technology">Technology</Link></li>
              <li><Link to="/wellbeing">Wellbeing</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/about">About Robert</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="tel:07710666500">07710 666500</a></li>
              <li><a href="mailto:robertpalser@outlook.com">robertpalser@outlook.com</a></li>
              <li><a href="http://www.chesstuition.org" target="_blank" rel="noreferrer">www.chesstuition.org</a></li>
              <li>Bwlch, Powys, Wales</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 Chess at Sea · Robert Palser · Bwlch, Powys, Wales</p>
          <p className="site">chessatsea.co.uk</p>
        </div>
      </div>
    </footer>
  );
}
